import firebase_api from '@/firebase/firebase_api'
import email_fct from '@/firebase/mails'
import firebase from 'firebase/app';
const object = {
    
    async sendCode(user) {
        var codeString = "";
        for (var code = 0;  code < 4; code++) {
            var codeItem = Math.floor(Math.random() * 9);
            codeString += String(codeItem);
        }
        var email = firebase.auth().currentUser.email
        firebase_api.api.getDb().collection("user").doc(email).update({
            code : codeString
        })
        this.params = {}
        this.params['code'] =  codeString;
        this.params['url'] = window.location.origin;
        email_fct.object.sendEmail(email, "MAIL_VERIF", this.params);
    
    },

    getById(idUser, fct) {
        firebase_api.api.getDb().collection("user").doc(idUser).get().then(user=>{
                if (user.exists) {
                    fct(user.data())
                }
                else    
                    fct(null);
        })
        .catch((error)=> {
            firebase_api.setLog("user", "get", error);
        });
    },
    get(fct) {
        firebase_api.api.getDb().collection("user").doc(firebase.auth().currentUser.uid).then(user=>{
                if (user.exists) {
                    fct(user.data())
                }
                else    
                    fct(null);
        })
        .catch((error)=> {
            firebase_api.setLog("user", "get", error);
        });
    },
   
    findAndRemoveDoublon(user, fct) {
        var nouvelId = user.uid;
        firebase_api.api.getDb().collection("user").where("email","==",user.email).get().then(snapshot=>{
            if (!snapshot.empty) {
                snapshot.docs.forEach(docUserFind=>{
                    if (docUserASupp.id != nouvelId) {
                        var userData = docUserFind.data();
                        userData.displayName = user.displayName,
                        userData.email= user.email;
                        userData.joueurs= user.joueurs,
                        userData.id= user.id;
                        firebase_api.api.getDb().collection("user").doc(user).set(
                            userData
                        )
                    }
                })
            }
        })
    },
    set(user, fct) {
        console.log(user);
        firebase_api.api.getDb().collection("user").doc(user.email).get().then(snapshot=>{
            if (snapshot.exists) {
                var userData = snapshot.data();
                userData.displayName= user.displayName,
                userData.authId = firebase.auth().currentUser.uid
                snapshot.ref.update({
                    displayName: user.displayName,
                    authId     : firebase.auth().currentUser.uid
                })  
                .then(()=>{
                    fct()
                })
                .catch((error)=> {
                    firebase_api.api.setLog("user", "set", error);
                });
                
            }
            else {
                console.log(user);
                firebase_api.api.getDb().collection("user").doc(user.email).set({
                    displayName: user.displayName,
                    email: user.email,
                    joueurs: user.joueurs,
                    authId : firebase.auth().currentUser.uid,
                    id: user.email
                })
                .catch((error)=> {
                    firebase_api.api.setLog("user", "set", error);
                });
            }
        })
    }
}


export default {
	object: object
}